module.exports = __webpack_public_path__ + "static/icons/icon-caret-down--white-bfba61d8059c68d7112c6198060eadc0.svg";